import React from 'react'
import Slider from '@material-ui/core/Slider'
import { useHotkeys } from 'react-hotkeys-hook'
import { useContext } from 'react'
import BackingTrackEditorContext from '../editorStore/BackingTrackGeneratorEditorContext'
import { EditorActionType } from '../editorStore/backingTrackGeneratorEditorActions'
import { Typography } from '@material-ui/core'


const ttDToMarks: any = {
  '0:0:1': 0,
  '0:0:2': 1,
  '0:1:0': 2,
  '0:2:0': 3,
  '1:0:0': 4
}

const valuesToTtd: any = {
  '0.25': '0:0:1',
  '0.5': '0:0:2',
  '1': '0:1:0',
  '2': '0:2:0',
  '4': '1:0:0',
}

const valuesToLabel: any = {
  '0.25': '1/4',
  '0.5': '1/2',
  '1': '1',
  '2': '2',
  '4': '4',
}

const marks = [{
  value: 0.25,
  // label: <span><sup>1</sup>&frasl;<sub>4</sub></span>,
  label: (
    <div className="frac">
      <span>1</span>
      <span className="bottom">4</span>
    </div>
  ),
}, {
  value: 0.5,
  label: (
    <div className="frac">
      <span>1</span>
      <span className="bottom">2</span>
    </div>
  ),
}, {
  value: 1,
  label: '1',
}, {
  value: 2,
  label: '2',
}, {
  value: 4,
  label: '4',
}]

const EditorChordLength = (props: any) => {

  const {
  } = props
  

  const [editor, dispatchEditor] = useContext(BackingTrackEditorContext)

  // console.log({ value: ttDToMarks[editor.state.currAddChordTtD], marksToTtd: valuesToTtd })
  
  
	useHotkeys('h', (e: any) => {
		e.preventDefault()
    dispatchEditor({
      type: EditorActionType.CurrAddChordTtdChange,
      payload: {
        ttD: '0:0:1'
      }
    })
	}, [])
	useHotkeys('j', (e: any) => {
		e.preventDefault()
    dispatchEditor({
      type: EditorActionType.CurrAddChordTtdChange,
      payload: {
        ttD: '0:0:2'
      }
    })
	}, [])
	useHotkeys('k', (e: any) => {
		e.preventDefault()
    dispatchEditor({
      type: EditorActionType.CurrAddChordTtdChange,
      payload: {
        ttD: '0:1:0'
      }
    })
	}, [])
	useHotkeys('l', (e: any) => {
		e.preventDefault()
    dispatchEditor({
      type: EditorActionType.CurrAddChordTtdChange,
      payload: {
        ttD: '0:2:0'
      }
    })
	}, [])
	useHotkeys('.', (e: any) => {
		e.preventDefault()
    dispatchEditor({
      type: EditorActionType.CurrAddChordTtdChange,
      payload: {
        ttD: '1:0:0'
      }
    })
	}, [])

	const handleAddChordTtd = (ttD: string) => {
		dispatchEditor({
			type: EditorActionType.CurrAddChordTtdChange,
			payload: {
				ttD
			}
		})
  }
  
  return (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      <Typography variant='h6' style={{ marginBottom: 8 }}><span style={{ marginRight: 12 }}>Duration:</span>{marks[ttDToMarks[editor.state.currAddChordTtD]].label}</Typography>

      <div style={{ flexGrow: 1 }}>
        <Slider
          value={marks[ttDToMarks[editor.state.currAddChordTtD]].value}
          // @ts-ignore
          onChange={(e: any, value: number) => handleAddChordTtd(valuesToTtd[value])}
          defaultValue={4}
          valueLabelFormat={(value: number) => valuesToLabel[value]}
          // getAriaValueText={(value: number) => valuesToLabel[value]}
          aria-labelledby="discrete-slider-restrict"
          step={null}
          valueLabelDisplay="auto"
          marks={marks}
          min={0}
          max={4}
          style={{
            width: 240,
            marginRight: 48
          }}
        />
      </div>
    </div>
  )}
  
  export default EditorChordLength
  